import React from 'react';

import ListView from '../ListView';

type Props = {
  search?: string;
  status?: string;
  [key: string]: any;
};

const Approved = ({ search, status = 'APPROVED', ...props }: Props) => {
  return <ListView {...props} status={status} search={search} />;
};

export default Approved;
